import NewUlcdIdentify from './src/main';

/* istanbul ignore next */
NewUlcdIdentify.install = function(Vue) {
  Vue.component(NewUlcdIdentify.name, NewUlcdIdentify);
};

export default NewUlcdIdentify;
